var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9935 0.333344C3.3135 0.333344 0.333496 3.32001 0.333496 7.00001C0.333496 10.68 3.3135 13.6667 6.9935 13.6667C10.6802 13.6667 13.6668 10.68 13.6668 7.00001C13.6668 3.32001 10.6802 0.333344 6.9935 0.333344ZM9.82016 11L7.00016 9.30001L4.18016 11L4.92683 7.79334L2.44016 5.64001L5.72016 5.36001L7.00016 2.33334L8.28016 5.35334L11.5602 5.63334L9.0735 7.78668L9.82016 11Z",
    fill: "#838489"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.846abfb669d369a4f74143183438492a.svg";
export { ForwardRef as ReactComponent };